'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisitableVenues = exports.mapStateToProps = exports.mapDispatchToProps = exports.VisitableVenuesUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _VenueCarousel = require('components/VenueCarousel/VenueCarousel');

var _Sagas = require('decorators/Sagas/Sagas');

var _decorator = require('helpers/decorator');

var _multitrack = require('helpers/multitrack');

var _device = require('redux/modules/device');

var _locale = require('redux/modules/locale');

var _bound = require('redux/saga/entities/bound');

var _visitableVenues = require('./visitableVenues.saga');

var _VerticalVenueList = require('./VerticalVenueList');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_DISPLAY_VENUES = 4;

var VisitableVenuesUnwrapped = exports.VisitableVenuesUnwrapped = function (_Component) {
  (0, _inherits3.default)(VisitableVenuesUnwrapped, _Component);

  function VisitableVenuesUnwrapped() {
    (0, _classCallCheck3.default)(this, VisitableVenuesUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (VisitableVenuesUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(VisitableVenuesUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(VisitableVenuesUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          loadVenues = _props.loadVenues,
          location = _props.location;

      loadVenues(location);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props,
          loadVenues = _props2.loadVenues,
          location = _props2.location;


      if (nextProps.location !== location) {
        loadVenues(nextProps.location);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          backgroundColor = _props3.backgroundColor,
          header = _props3.header,
          isClickable = _props3.isClickable,
          showAsList = _props3.showAsList,
          subheader = _props3.subheader,
          venues = _props3.venues;


      var validVenues = (0, _visitableVenues.filterValidVenues)(venues);

      if (validVenues.length < MIN_DISPLAY_VENUES) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'bg--' + (backgroundColor || 'white') },
        _react2.default.createElement(
          'div',
          { className: 'venues' },
          _react2.default.createElement(
            'h2',
            { className: 'gamma text--center mb' },
            header || _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'visitable-venues.header.default',
              defaultMessage: 'Studios you can visit'
            })
          ),
          subheader && _react2.default.createElement(
            'p',
            { className: 'venues__subtitle' },
            subheader
          ),
          showAsList ? _react2.default.createElement(
            'div',
            { className: 'venues__list' },
            _react2.default.createElement(_VerticalVenueList.VerticalVenueList, {
              elements: validVenues,
              showCount: true
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'venues__carousel' },
            _react2.default.createElement(_VenueCarousel.VenueCarousel, {
              elements: validVenues,
              nolink: !isClickable,
              showCount: true
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text--center' },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: '/explore',
                className: 'bt bt--primary bt--outline bt--lg',
                onClick: function onClick() {
                  return (0, _multitrack.ga)('Studios Module', 'Clicked Explore all studios', null, 0);
                }
              },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'pricing.explore-all-studios',
                defaultMessage: 'Explore all studios'
              })
            )
          )
        )
      );
    }
  }]);
  return VisitableVenuesUnwrapped;
}(_react.Component);

var mapDispatchToProps = exports.mapDispatchToProps = {
  loadVenues: _visitableVenues.loadVenues
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  var isMobile = (0, _device.selectIsMobile)(state);
  var location = (0, _locale.selectUserLocation)(state);
  var venuesData = _bound.nearbyPopularVenues.data(state, (0, _visitableVenues.nearbyVenuesKey)(location));

  return {
    location: location,
    showAsList: isMobile && ownProps.canShowVerticalViewInMobile,
    venues: venuesData ? venuesData.venues : []
  };
};

VisitableVenuesUnwrapped.propTypes = {
  backgroundColor: _propTypes2.default.oneOf(['white', 'light']),
  header: _propTypes2.default.string,
  isClickable: _propTypes2.default.bool,
  loadVenues: _propTypes2.default.func.isRequired,
  location: _propTypes2.default.shape({
    lat: _propTypes2.default.number,
    lon: _propTypes2.default.number
  }),
  showAsList: _propTypes2.default.bool.isRequired,
  subheader: _propTypes2.default.string,
  venues: _propTypes2.default.array
};

var VisitableVenues = exports.VisitableVenues = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({ watch: _visitableVenues.watchSaga }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(VisitableVenuesUnwrapped);